class ServiceApi {
  constructor(service_name, prefix) {
    this._request_func = null;
    this._raw_request_func = null;
    this.name = service_name; // used for main api binding like api.<name>
    this.prefix = prefix; //text prefix for rpc request
    this.dev_mode = false;
  }
  enableDevMode() {
    this.dev_mode = true;
  }
  setRequestFunc(request_func) {
    this._request_func = request_func;
  }
  setRawRequestFunc(batch_request_func) {
    this._raw_request_func = batch_request_func;
  }

  /**
   *
   * @return {ServiceMethodResponse}
   */
  request(method, request_data = {}, request_meta = null) {
    return this._request_func(method, request_data, request_meta);
  }
  rawRequest(request_data) {
    return this._raw_request_func(request_data);
  }
}
export default ServiceApi;
/**
 * @typedef {Object} ServiceMethodResponse
 * @property {function} run
 * @property {object} request
 * @property {function} batch
 */
